'use client';

import React from 'react';

const STORAGE_KEY = 'live-vconsole-enabled';

/**
 * Enables the mobile VConsole only when explicitly requested with `?debug=1`.
 * The setting persists on this origin until a page is opened with `?debug=0`.
 */
export function MobileDebugConsole() {
  React.useEffect(() => {
    const requested = new URLSearchParams(window.location.search).get('debug');
    let enabled = requested === '1';

    try {
      if (requested === '1') {
        window.localStorage.setItem(STORAGE_KEY, '1');
      } else if (requested === '0') {
        window.localStorage.removeItem(STORAGE_KEY);
      } else {
        enabled = window.localStorage.getItem(STORAGE_KEY) === '1';
      }
    } catch {
      // Private browsing modes may deny storage access; the URL flag still works.
    }

    if (!enabled || requested === '0') return;

    let disposed = false;
    let instance: { destroy: () => void } | undefined;

    void import('vconsole').then(({ default: VConsole }) => {
      if (disposed) return;
      instance = new VConsole({ theme: 'dark' });
      console.info('[Live Debug] VConsole enabled');
    });

    return () => {
      disposed = true;
      instance?.destroy();
    };
  }, []);

  return null;
}
